export default "__VITE_ASSET__06c2228b__"